import {
  WorkflowStatus,
  WorkflowStepType,
  WorkflowTaskPriorityLabel,
  type WorkflowTaskType,
  WorkflowTaskTypes,
  WorkflowTemplateStatus,
} from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/index.ts";

export const WorkflowTaskTypeOptions = convertMapToOpts(
  WorkflowTaskTypes,
  ([_, value]) => toTitleCaseString(value)
);

export const WorkflowStepTypeOptions = convertMapToOpts(
  WorkflowStepType,
  ([_, value]) => toTitleCaseString(value)
);

export const WorkflowTemplateStatusOptions = convertMapToOpts(
  WorkflowTemplateStatus,
  ([_, value]) => toTitleCaseString(value)
);

export const WorkflowStatusOptions = convertMapToOpts(
  WorkflowStatus,
  ([_, value]) => toTitleCaseString(value)
);

export const WorkflowTaskPriorityIdToLabelMap: Record<
  WorkflowTaskType["priority_id"],
  WorkflowTaskType["priority_label"]
> = {
  0: WorkflowTaskPriorityLabel.NONE,
  1: WorkflowTaskPriorityLabel.HIGH,
  2: WorkflowTaskPriorityLabel.HIGHEST,
};

export const UpdateAttributesSystemActionPrimaryAttributesThatCanBeUpdated = [
  "status",
];
